import { confirmDialog, openModal } from '@bn-games/ui-shell';
import { acceptsDraw } from '../ai/AiPlayer.js';
import { opposite } from '../game/types.js';
import { t } from '../i18n/I18n.js';
import type { Difficulty } from '../settings/types.js';
import { sideLabel } from './GameOverHost.js';
import type { LocalMatch } from './LocalMatch.js';

/**
 * Offer a draw in a local game. The bot decides from its evaluation; in
 * hot-seat the other player answers a confirm dialog on the same screen.
 */
export function offerDraw(match: LocalMatch, difficulty: Difficulty): void {
  if (match.state.isOver) return;
  if (match.opponent === 'bot') {
    if (acceptsDraw(match.state.position, opposite(match.humanColor), difficulty)) {
      match.agreeDraw();
      return;
    }
    const modal = openModal({
      title: t('game.draw.offer'),
      body: t('game.draw.botDeclined'),
      actions: [{ label: t('gameOverlay.close'), primary: true, onClick: () => modal.close() }],
    });
    modal.focusPrimary();
    return;
  }
  const side = sideLabel(match.state.turn);
  const other = sideLabel(opposite(match.state.turn));
  void confirmDialog({
    title: t('game.draw.hotSeatTitle'),
    message: t('game.draw.hotSeatBody', { side, other }),
    confirmLabel: t('game.draw.accept'),
    cancelLabel: t('game.draw.decline'),
  }).then((ok) => {
    if (ok) match.agreeDraw();
  });
}
